var map = {
	"./arrow-blue.svg": "658b",
	"./arrow.svg": "27e4",
	"./calendar.svg": "d71f",
	"./check.svg": "51c7",
	"./close.svg": "2930",
	"./error.svg": "7314",
	"./logo-base.svg": "2b9c",
	"./logo-client.svg": "98be",
	"./logo-login.svg": "d97d",
	"./logo.svg": "e347",
	"./preloader.svg": "c8b8",
	"./time.svg": "56de"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";